export function initControls({ 
  setCurrentSide: _setCurrentSide,
  updateNotional, 
  onSubscribe 
}: { setCurrentSide: (side: 'BUY' | 'SELL') => void; updateNotional: () => void; onSubscribe: () => Promise<void>; }): void {
  const priceInp = document.getElementById('price') as HTMLInputElement | null;
  const sizeInp = document.getElementById('size') as HTMLInputElement | null;
  const btn = document.getElementById('btn') as HTMLButtonElement | null;
  priceInp?.addEventListener('input', updateNotional);
  sizeInp?.addEventListener('input', updateNotional);
  if (btn) {
    btn.onclick = async () => {
      try {
        await onSubscribe();
      } catch (e) {
        console.error('[controls] Subscribe error:', e);
      }
    };
  }
}
